import {
  isChannel,
  isInvite,
  isPrivateLink,
  isSignage
} from './utils/url';

import {
  getDeckIndex,
  getOtp,
  getSlideIndex
} from './selectors/index';

/**
 * This defines all the query parameters that the app uses. These definitions
 * aid with parsing query parameters from the URL (which are in turn used to
 * update redux state). This approach means that redux state is the source of
 * truth for all query parameters - *don't* read query parameters directly
 * from the URL.
 *
 * A query parameter definition consists of:
 *
 * - isApplicable: when this returns true, the value of the query parameter is
 * read from redux state and then used when rewriting the URL.
 *
 * - defaultValue: (optional) a value to use for numeric query parameters when
 * not present.
 *
 * - fallback: (optional) an alternative name for the query parameter.
 *
 * - selector: the redux selector that gets the query parameter value from
 * state. Needless to say this corresponds to where the reducers write the
 * value to.
 *
 * - type: how the query parameter value should be parsed when being read out
 * of the URL. Set this to either Number or String.
 *
 * - writeToUrl: whether the parameter is included in the URL. Set this to
 * false when you want to read the query parameter's initial value from the
 * URL but then just keep it in state (i.e. the query parameter will be
 * removed from the URL).
 */
export default {
  // A channel shows a series of decks in a folder, this is the index of the
  // deck being displayed.
  deckIndex: {
    isApplicable: isChannel,
    selector: getDeckIndex,
    type: Number,
  },
  // One-time password; used to authenticate without the need for a username
  // and password.
  otp: {
    isApplicable: () => isInvite() || isPrivateLink() || isSignage(),
    selector: getOtp,
    type: String,
    writeToUrl: true,
  },
  // The index of the slide being displayed.
  slideIndex: {
    defaultValue: 0,
    isApplicable: () => true,
    fallback: 'sceneIndex',
    selector: getSlideIndex,
    type: Number,
  },
};
